import { render, staticRenderFns } from "./SmsResultModal.vue?vue&type=template&id=2d50d49e&scoped=true"
import script from "./SmsResultModal.vue?vue&type=script&lang=js"
export * from "./SmsResultModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d50d49e",
  null
  
)

export default component.exports